module.exports = __webpack_public_path__ + "static/img/slide-3.e1bc712.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/slides/slide-3.jpg
// module id = DKis
// module chunks = 1